import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnDeleteIcon from '../../../../icons/OnDeleteIcon';
import OnEditIcon from '../../../../icons/OnEditIcon';
import { formatDate } from '../../../../utils/dateFunctions';

import table from '../../../../commonStyles/tables.module.css';

const QuitReviewRow = ({ row, isDisabled, isDeleteDisabled, onEdit, onDelete }) => {
    return (
        <TableRow hover className={table.basicRowStripes}>
            <TableCell>{formatDate(row.eventDate)}</TableCell>
            <TableCell align="center">{row.intervention}</TableCell>
            <TableCell align="center">{row.selfReportedQuit}</TableCell>
            <TableCell align="center">{row.coValidation ? 'Yes' : 'No'}</TableCell>
            <TableCell align="center">{row.coResult}</TableCell>
            <TableCell align="center">{row.quitReviewSuccessful ? 'Yes' : 'No'}</TableCell>
            <TableCell align="right">
                <OnEditIcon onEdit={() => onEdit(row)} active={!isDisabled} />
            </TableCell>
            <TableCell align="right">
                <OnDeleteIcon onDelete={() => onDelete(row)} active={!isDeleteDisabled} />
            </TableCell>
        </TableRow>
    );
};

QuitReviewRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    isDeleteDisabled: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
};

export default QuitReviewRow;
